module.exports = __webpack_public_path__ + "static/media/Learner.bd8361b4.png";